var map = {
	"./navigation/en-US.json": 68643,
	"./navigation/zh-CN.json": 32693,
	"./news/en-US.json": 38298,
	"./news/zh-CN.json": 73504,
	"./pages/en-US.json": 43601,
	"./pages/zh-CN.json": 67063,
	"./products/en-US.json": 84141,
	"./products/zh-CN.json": 1443
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 84726;
module.exports = webpackAsyncContext;